export default __webpack_public_path__ + "ffb2cd2f80ba872b34cea737b5fbda6a.png";